import { Network } from 'turbos-clmm-sdk';

const production = {
  sui_network: Network.mainnet,
  api_url: 'https://api.turbos.finance',
  // api_url: 'http://54.234.151.46:6002',
  explorer_url: {
    suivision: {
      txb: 'https://suivision.xyz/txblock/{{txb}}',
      account: 'https://suivision.xyz/account/{{account}}',
      object: 'https://suivision.xyz/object/{{object}}',
      coin: 'https://suivision.xyz/coin/{{coin}}',
    },
    suiscan: {
      txb: 'https://suiscan.xyz/mainnet/tx/{{txb}}',
      account: 'https://suiscan.xyz/mainnet/account/{{account}}',
      object: 'https://suiscan.xyz/mainnet/object/{{object}}',
      coin: 'https://suiscan.xyz/mainnet/coin/{{coin}}',
    },
    sui_explorer: {
      txb: 'https://suiexplorer.com/txblock/{{txb}}',
      account: 'https://suiexplorer.com/address/{{account}}',
      object: 'https://suiexplorer.com/object/{{object}}',
      coin: 'https://suiexplorer.com/object/{{coin}}',
    },
  },
  rpc: <Record<string, string>>{
    suiscan: 'https://rpc-mainnet.suiscan.xyz/',
    sui_Official: 'https://fullnode.mainnet.sui.io:443',
    suiet: ' https://mainnet.suiet.app/',
    shinami: 'https://api.shinami.com/node/v1/sui_mainnet_bb70bc6a7d6d04694c4c719f0b6f27aa',
  },
  // fullnode: 'https://sui-mainnet-endpoint.blockvision.org',
  // suinami node: https://api.shinami.com/node/v1/sui_mainnet_bb70bc6a7d6d04694c4c719f0b6f27aa
  // fullnode: 'https://turbos-mainnet-endpoint.blockvision.org',
  fullnode: 'https://api.shinami.com/node/v1/sui_mainnet_bb70bc6a7d6d04694c4c719f0b6f27aa',
  // fullnode: 'https://fullnode.mainnet.sui.io:443',
  pyth_endpoint: 'https://hermes.pyth.network',
  deepbook_env: 'mainnet' as 'mainnet' | 'testnet',
  deepbook_pools: [
    {
      poolKey: 'DEEP_SUI',
      address: ``,
      baseCoin: 'DEEP',
      quoteCoin: 'SUI',
    },
  ] as { poolKey: string; address: string; baseCoin: string; quoteCoin: string }[],
  deepbook_package_id: '',
  deepbook_coins: [
    {
      type: '0xdeeb7a4662eec9f2f3def03fb937a663dddaa2e215b8078a284d026b7946c270::deep::DEEP',
      symbol: 'DEEP',
      decimals: 6,
    },
    {
      type: '0x2::sui::SUI',
      symbol: 'SUI',
      decimals: 9,
    },
    {
      type: '0x5d4b302506645c37ff133b98c4b50a5ae14841659738d6d733d59d0d217a93bf::coin::COIN',
      symbol: 'USDC',
      decimals: 6,
    },
    {
      type: `0xc060006111016b8a020ad5b33834984a437aaa7d3c74c18e09a95d48aceab08c::coin::COIN`,
      symbol: 'USDT',
      decimals: 6,
    },
    {
      type: `0xaf8cd5edc19c4512f4259f0bee101a40d41ebed738ade5874359610ef8eeced5::coin::COIN`,
      symbol: 'WETH',
      decimals: 8,
    },
  ] as {
    type: string;
    decimals: number;
    symbol: string;
  }[],
};

export type Config = typeof production;

export default production;
